/*
 * @Date: 2020-08-31 14:09:19
 * @Author: lvjun
 * @Description: vuex
 */
import * as Types from "../mutation-types";
let lang = localStorage.getItem("lang") || "CN";
const base = {
  state: {
    user: JSON.parse(localStorage.getItem("userData")) || null, // 用户信息
    token: localStorage.getItem("YL_TOKEN") || "",
    lang, // 语言
    tableHeight: 0,
    menu: JSON.parse(localStorage.getItem("MENU")) || null, // 系统菜单
    btnList: JSON.parse(localStorage.getItem("BTNLIST")) || {}, //按钮
    vueStorage: {
      servicemessageEvent: "", // 一键录单
      servicemessageUserList: "", // 在线客服当前接待列表
      servicemessageUserCode: "", // 在线客服切换接待用户
    }, // postMessage
    // 平台在线传递数据
    trillStorage: {
      rapidCatalogue: "", // 一键录单
      receptionUserList: "", // 紫金山当前接待列表
      receptionUserCode: "", // 紫金山切换接待用户
    },
    // 自研平台
    imStorage: {
      imCatalogue: "", // 一键录单
      imUserList: [], // 当前接待列表
      imClickChat: "", // 切换接待用户
      imOrderSuggestData:'' //录单小助手数据
    }
  },
  mutations: {
    // postMessage
    [Types.SET_VUESTORAGE]: (state, data) => {
      const {
        servicemessageEvent,
        servicemessageUserList,
        servicemessageUserCode,
      } = data;
      if (servicemessageEvent)
        state.vueStorage.servicemessageEvent = servicemessageEvent;
      if (servicemessageUserList)
        state.vueStorage.servicemessageUserList =
          servicemessageUserList;
      if (servicemessageUserCode)
        state.vueStorage.servicemessageUserCode =
          servicemessageUserCode;
    },
    // postMessage
    [Types.SET_TRILLSTORAGE]: (state, data) => {
      const { rapidCatalogue, receptionUserList, receptionUserCode } =
        data;
      if (rapidCatalogue)
        state.trillStorage.rapidCatalogue = rapidCatalogue;
      if (receptionUserList)
        state.trillStorage.receptionUserList = receptionUserList;
      if (receptionUserCode)
        state.trillStorage.receptionUserCode = receptionUserCode;
    },
    // postMessage 自研
    [Types.SET_IMSTORAGE]: (state, data) => {
      const { imCatalogue, imUserList, imClickChat,imOrderSuggestData } =
        data;
      if (imCatalogue)
        state.imStorage.imCatalogue = imCatalogue;
      if (imUserList?.length) {
        state.imStorage.imUserList.length = 0
        state.imStorage.imUserList.push(...imUserList);
      }
      if (imClickChat)
        state.imStorage.imClickChat = imClickChat;
      if(imOrderSuggestData){
        console.log(imOrderSuggestData,'imOrderSuggestData')
        const { payload } = imOrderSuggestData
        state.imStorage.imOrderSuggestData = imOrderSuggestData?.payload
        // Object.assign(state.imStorage.imOrderSuggestData,{
        //   [payload?.sessionId]: imOrderSuggestData
        // })
      }
    },
    // 用户信息
    [Types.SET_USER]: (state, data) => {
      state.user = data;
      localStorage.setItem("userData", JSON.stringify(data));
    },
    // 用户token
    [Types.SET_TOKEN]: (state, data) => {
      state.token = data;
      localStorage.setItem("YL_TOKEN", data);
    },
    // 用户系统菜单
    [Types.SET_MENU]: (state, data) => {
      state.menu = data;
      localStorage.setItem("MENU", JSON.stringify(data));
    },
    // 设置按钮权限
    [Types.SET_BTNLIST]: (state, data) => {
      state.btnList = data;
      localStorage.setItem("BTNLIST", JSON.stringify(data));
    },
    // 退出
    [Types.LOGIN_OUT]: (state) => {
      // 退出登录，清楚本地缓存
      localStorage.removeItem("userData");
      localStorage.removeItem("YL_TOKEN");
      localStorage.removeItem("VISITED_VIEWS");
      localStorage.removeItem("MENU");
      localStorage.removeItem("BTNLIST");
      state.token = "";
      state.user = {};
    },
    SET_TABLE_HEIGHT: (state, data) => {
      state.tableHeight = data;
    },
    // 设置用户分机号
    SET_USER_EXTENSION_NO: (state, extensionNo) => {
      if (state.user) {
        state.user.extensionNo = extensionNo;
        // 更新 localStorage 中的用户信息
        localStorage.setItem("userData", JSON.stringify(state.user));
      }
    },
  },
  actions: {
    // 设置
    [Types.SET_VUESTORAGE]({ commit } = {}, value) {
      commit("SET_VUESTORAGE", value);
    },
    // 设置
    [Types.SET_TRILLSTORAGE]({ commit } = {}, value) {
      commit("SET_TRILLSTORAGE", value);
    },
    // 设置
    [Types.SET_IMSTORAGE]({ commit } = {}, value) {
      commit("SET_IMSTORAGE", value);
    },
    // 登录初始化
    [Types.LOGIN_INIT]({ commit } = {}, value) {
      const { user, token, menu } = value;
      commit("SET_USER", user);
      commit("SET_TOKEN", token);
      commit("SET_MENU", menu);
    },
    // 退出
    [Types.LOGIN_OUT]({ commit } = {}) {
      commit("LOGIN_OUT");
      commit("tags/LOGIN_OUT", {}, { root: true });
    },
    setTableHeight: ({ commit } = {}, value) => {
      commit("SET_TABLE_HEIGHT", value);
    },
    [Types.SET_BTNLIST]({ commit } = {}, value) {
      const { btnList } = value;
      commit("SET_BTNLIST", btnList);
    },
    // 设置用户分机号
    [Types.SET_USER_EXTENSION_NO]({ commit } = {}, value) {
      commit("SET_USER_EXTENSION_NO", value);
    },
  },
  getters: {
    user: (state) => state.user,
    token: (state) => state.token || "",
    lang: (state) => state.lang,
    tableHeight: (state) => state.tableHeight,
    menu: (state) => state.menu,
    btnList: (state) => state.btnList,
    vueStorage: (state) => state.vueStorage,
    trillStorage: (state) => state.trillStorage,
    imStorage: (state) => state.imStorage,
  },
};
export default base;
